import { ChangeEvent } from 'react';
import CustomModal from '../CustomModal';
import { ModalType } from '@/store/modal';
import { Alert, Container, Flex, Select, Textfield } from '@legion-ui/core';
import { ModalContent } from '../CustomModal/ModalContent';
import { notify } from '@/services/notify';
import { BsInfoCircleFill } from 'react-icons/bs';
import { UsersType } from '@/@types/user.types';
import Button from '../Button';
import { usePasswordStore } from '@/store/password';
import {
  usePublisherInputStore,
} from '@/store/police/publisher.input';
import {
  axiosClient,
  getRefreshToken,
  updatePolicy,
  updateUserStatus,
  verifyUserPassword,
  whitelistUser,
} from '@/services/utilities';
import { userStore } from '@/store/users';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useDeveloperInputStore } from '@/store/police/developer.input';
import { RoleInputState, useDraftInputState,  UserRole } from '@/store/police/draft.input';
import { useTemporaryInputState } from '@/store/police/temporary.input';
import useLoadingStore from '@/store/loading';
import LoadingOverlay from '../LoadingOverlay';
import { useAdminInputStore } from '@/store/police/admin.input';

interface ModalContainerProps {
  activeModal: ModalType | null;
  toggleModal: (modal: ModalType | null) => void;
  user: UsersType;
}

const ModalContainer = ({
  activeModal,
  toggleModal,
  user,
}: ModalContainerProps) => {
  const {
    tempDeveloperInput,
    setTempDeveloperInput,
    tempPublisherInput,
    setTempPublisherInput,
    tempAdminInput,
    setTempAdminInput,
  } = useTemporaryInputState((state) => state);

  const { setLoading } = useLoadingStore();

  const clearTempDeveloperInput = () => {
    setTempDeveloperInput('role', null);
    setTempDeveloperInput('userAllowed', null);
    toggleModal(null);
  };

  const clearTempPublisherInput = () => {
    setTempPublisherInput('role', null);
    setTempPublisherInput('userAllowed', null);
    toggleModal(null);
  };

  const clearTempAdminInput = () => {
    setTempAdminInput('role', null);
    setTempAdminInput('userAllowed', null);
    toggleModal(null);
  };

  const {
    showPassword,
    toggleShowPassword,
    password,
    passwordAttempt,
    setValue: setValuePasswordStore,
    setPasswordAttempt,
    clear: clearAllPasswordState,
  } = usePasswordStore();
  // Handle update role
  const publisherStore = usePublisherInputStore((state) => ({
    userAllowed: state.userAllowed,
    role: state.role,
    setValue: state.setValue,
    clear: state.clear,
  }));
  const adminStore = useAdminInputStore((state) => ({
    userAllowed: state.userAllowed,
    role: state.role,
    setValue: state.setValue,
    clear: state.clear,
  }));
  const userLogedIn = userStore((state) => state.userLogedIn);
  
  const { setUserSearched } = userStore((state) => ({
    setUserSearched: state.setUserSearched,
  }));

  const draftInputState = useDraftInputState((state) => state);
  const developerInputStore = useDeveloperInputStore((state) => state);

  const handleLogout = async () => {
    try {
      const { data } = await axiosClient.get(
        `/auth/logout/${getRefreshToken()}`,
      );
      //alert('logout sukses');
      
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      window.open(data, '_self');
    } catch (err: any) {
      notify(err.message, { type: 'error' });
    }
  };

  if (passwordAttempt === 3) {
    setValuePasswordStore('passwordAttempt', 0);
    localStorage.setItem('PASSWORD_ATTEMPT', '0');
    alert('You have reach maximum attempt, please login to proceed');
    handleLogout();
  }

  const handlePasswordChange = (e: ChangeEvent<HTMLInputElement>) => {
    setValuePasswordStore('password', e.target.value);
  };

  // const handleVerifyPassword = async (email: string, password: string) => {
  //   try {
  //     console.log('handleVerifyPassword');
  //     //await verifyUserPassword(email, password);
  //     setValuePasswordStore('passwordAttempt', 0);
  //     localStorage.setItem('PASSWORD_ATTEMPT', '0');
  //     // ONLY UPDATE USER STATUS
  //     if (
  //       whitelistStore.userStatus !== null &&
  //       whitelistStore.userRoleStatus === null
  //     ) {
  //       console.log('call handleUpdatePolicy');
  //       handleUpdatePolicy();
  //     } else if (
  //       // WHITELIST USER
  //       !user.isAdmin &&
  //       !user.isPublisher &&
  //       developerInputStore.userRoleStatus === null &&
  //       whitelistStore.userStatus !== null
  //     ) {
  //       console.log('call handleWhitelistUser');
  //       handleWhitelistUser();
  //     } else {
  //       handleUpdatePolicy();
  //     }
  //     clearAllPasswordState();
  //   } catch (err: any) {
  //     setPasswordAttempt();
  //     const attempt = localStorage.getItem('PASSWORD_ATTEMPT');
  //     setValuePasswordStore('password', '');
  //     notify(`(${attempt}/3 try) Email or password is not correct`, {
  //       type: 'error',
  //     });
  //   }
  // };

  //fungsi ini untuk update role tanpa verifikasi password
  const handleSubmitUpdateRole = async () => {
    try {
      // ONLY UPDATE USER STATUS
      toggleModal(null)
      setLoading(true)
      setTimeout(() => {
        setLoading(false);
      }, 5 * 1000);
      if (
        publisherStore.userAllowed !== null ||
        adminStore.userAllowed !== null
      ) {
        handleUpdatePolicy();
        clearAllPasswordState();
        // clearTempAdminInput();
        // clearTempPublisherInput();
        // clearTempDeveloperInput();
      } 
    } catch (err: any) {
      notify(`Error when try to update policy`, {
        type: 'error',
      });
    }
  };

  // const handleWhitelistUser = async () => {
  //   console.log('Whitelist function called');
  //   if (whitelistStore.role === null) {
  //     notify('Role is required, Please add user role', {
  //       type: 'error',
  //     });
  //     toggleModal(null);
  //     return;
  //   }
  //   try {
  //     await whitelistUser(
  //       {
  //         username: user.username,
  //         active: whitelistStore.userRoleStatus!,
  //         allow: whitelistStore.userStatus!,
  //       },
  //       whitelistStore.role,
  //     );
  //     setUserSearched([
  //       {
  //         ...user,
  //         isAdmin: whitelistStore.role === 'admin-portal',
  //         isPublisher: whitelistStore.role === 'publisher-portal',
  //       },
  //     ]);
  //   } catch (err: any) {
  //     notify(err.message || 'Cannot whitelist user', { type: 'error' });
  //   }
  //   notify('Whitelist user succeed', { type: 'success' });
  //   toggleModal(null);
  //   whitelistStore.setValue('role', null);
  //   whitelistStore.setValue('userRoleStatus', true);
  //   whitelistStore.setValue('userStatus', true);
  // };

  // Handle update policy
  const handleUpdatePolicy = async () => {
    // Handle update policy logic here
    console.log('Handle policy function called');
    try {
      await Promise.all(
        draftInputState.drafts.map(async (draft: RoleInputState) => {
          await updatePolicy({
            username: user.username,
            active: true,
            allow: draft.userAllowed!,
            portal: draft.role!,
          });
        }),
      );
      notify('Update policy has changed', { type: 'success' });
    } catch (err: any) {
      notify(err.message || 'Update policy has been error', { type: 'error' });
    }
    draftInputState.clear();
    toggleModal(null);
  };

  const handleChangeDeveloperStatus = () => {
    developerInputStore.setValue('role', tempDeveloperInput.role);
    developerInputStore.setValue(
      'userAllowed',
      tempDeveloperInput.userAllowed,
    );
    draftInputState.updateDraft('developer-portal', {
      userAllowed: tempDeveloperInput.userAllowed,
    });
    toggleModal(null);
  };

  const handleChangeRolePublisherStatus = () => {
    publisherStore.setValue(
      'userAllowed',
      tempPublisherInput.userAllowed,
    );
    draftInputState.updateDraft(tempPublisherInput.role, {
      role: tempPublisherInput.role,
      userAllowed: tempPublisherInput.userAllowed,
    });
    toggleModal(null);
  };

  const handleChangeRoleAdminStatus = () => {
    adminStore.setValue(
      'userAllowed',
      tempAdminInput.userAllowed,
    );
    draftInputState.updateDraft(tempAdminInput.role, {
      role: tempAdminInput.role,
      userAllowed: tempAdminInput.userAllowed,
    });
    toggleModal(null);
  };

  const options = [
    {
      label: 'Allowed',
      value: 'allowed',
    },
    {
      label: 'Prohibited',
      value: 'prohibited',
    },
  ];

  return (
    <>
      <LoadingOverlay/>
      <Container>
      
        {/* Modal User Role (Developer) */}
        <CustomModal
          show={activeModal === ModalType.Developer}
          onClose={() => toggleModal(null)}
          title={`Are you sure to ${
            user?.isDeveloper ? 'prohibited' : 'allowed'
          } this user as a developer?`}
        >
          <Alert
            bordered
            icon={<BsInfoCircleFill size={18} />}
            show
            className="flex items-center"
          >
            <span className="text-sm text-black opacity-80">
              When using the Apilogy platform, the default user role is developer.
              If user is prohibited as a developer, user cannot access the developer
              portal and all APIs become inactive automatically.
            </span>
          </Alert>
          <ModalContent content="By updating user role, you understand that each role has different access and capabilities in using the Apilogy platform." />
          <Flex>
            <Select
              className="w-full"
              placeholder={user?.isDeveloper ? 'Allowed' : 'Prohibited'}
              onChange={([e]) => {
                setTempDeveloperInput('role', 'developer-portal');
                setTempDeveloperInput('userAllowed', e.value === 'allowed');
              }}
              options={options}
              value={[
                tempDeveloperInput.userAllowed ?? user.isDeveloper
                  ? options[0]
                  : options[1],
              ]}
            />
          </Flex>
          <Flex className="gap-3" alignX="center" pt="1rem">
            <Button
              type="button"
              variant="outline"
              onClick={clearTempDeveloperInput}
            >
              Cancel
            </Button>
            <Button type="button" onClick={handleChangeDeveloperStatus}>
              Save changes
            </Button>
          </Flex>
        </CustomModal>

        {/* Modal User Role (Publisher)*/}
        <CustomModal
          show={activeModal === ModalType.Publisher}
          onClose={() => toggleModal(null)}
          title={`Are you sure to ${
            user?.isPublisher ? 'prohibited' : 'allowed'
          } this user as a publisher?`}
        >
          <Alert
            bordered
            icon={<BsInfoCircleFill size={18} />}
            show
            className="flex items-center"
          >
            <span className="text-sm text-black opacity-80">
              When the user is allowed as a publisher, user will have access to
              the publisher portal. Conversely, if user is prohibited as a
              publisher, access to the publisher portal is revoked.
            </span>
          </Alert>
          <ModalContent content="By updating user role, you understand that each role has different access and capabilities in using the Apilogy platform." />
          <Flex>
            <Select
              className="w-full"
              onChange={([e]) => {
                setTempPublisherInput('role', 'publisher-portal');
                setTempPublisherInput('userAllowed', e.value === 'allowed');
              }}
              value={[
                tempPublisherInput.userAllowed ??
                user.isPublisher
                  ? options[0]
                  : options[1],
              ]}
              options={options}
            />
          </Flex>
          <Flex className="w-full gap-3" alignX="center" pt="1rem">
            <Button
              type="button"
              variant="outline"
              onClick={clearTempPublisherInput}
            >
              Cancel
            </Button>
            <Button type="button" onClick={() => handleChangeRolePublisherStatus()}>
              Yes, sure
            </Button>
          </Flex>
        </CustomModal>

        {/* Modal User Role (Admin)*/}
        <CustomModal
          show={activeModal === ModalType.Admin}
          onClose={() => toggleModal(null)}
          title={`Are you sure to ${
            user?.isAdmin ? 'prohibited' : 'allowed'
          } this user as an admin?`}
        >
          <Alert
            bordered
            icon={<BsInfoCircleFill size={18} />}
            show
            className="flex items-center"
          >
            <span className="text-sm text-black opacity-80">
              When the user is allowed as an admin, user will be able to access
              the admin portal and perform admin tasks. Conversely, if user is
              prohibited as an admin, user will not be able to access the admin
              portal and perform admin tasks.
            </span>
          </Alert>
          <ModalContent content="By updating user role, you understand that each role has different access and capabilities in using the Apilogy platform." />
          <Flex>
            <Select
              className="w-full"
              value={[
                tempAdminInput.userAllowed ??
                user.isAdmin
                  ? options[0]
                  : options[1],
              ]}
              onChange={([e]) => {
                setTempAdminInput('role', 'admin-portal');
                setTempAdminInput('userAllowed', e.value === 'allowed');
              }}
              options={options}
            />
          </Flex>
          <Flex className="w-full gap-3" alignX="center" pt="1rem">
            <Button
              type="button"
              variant="outline"
              onClick={clearTempAdminInput}
            >
              Cancel
            </Button>
            <Button type="button" onClick={handleChangeRoleAdminStatus}>
              Yes, sure
            </Button>
          </Flex>
        </CustomModal>

        {/* Modal User Status */}
        {/* <CustomModal
          show={activeModal === ModalType.Status}
          onClose={() => toggleModal(null)}
          title="Are you sure to change user status?"
        >
          <ModalContent content="Changing user status will affect user access in using the Apilogy platform. By changing status, user will gain or lose login access to Apilogy platform." />
          <Flex className="w-full gap-3" alignX="center" pt="1rem">
            <Button
              type="button"
              variant="outline"
              onClick={clearTempWhitelistInput}
            >
              Cancel
            </Button>
            <Button type="button" onClick={handleChangeStatus}>
              Yes, sure
            </Button>
          </Flex>
        </CustomModal> */}

        {/* Modal Update */}
        <CustomModal
          show={activeModal === ModalType.Update}
          onClose={() => toggleModal(null)}
          title="Control Policy"
        >
          <ModalContent content="Changing status or roles will affect user behavior in using the Apilogy platform. Are you sure you want to save the changes?." />
          <Flex className="w-full gap-3" alignX="center" pt="1rem">
            <Button
              type="button"
              variant="outline"
              onClick={() => toggleModal(null)}
            >
              Cancel
            </Button>
            <Button
              type="button"
              onClick={() => handleSubmitUpdateRole()}
            >
              Save
            </Button>
          </Flex>
        </CustomModal>

        {/* Modal Whitelist */}
        {/* <CustomModal
          show={activeModal === ModalType.whitelistUser}
          onClose={() => toggleModal(null)}
          title="Are you sure whitelist"
        >
          <ModalContent content="This action will grant the user access to the admin portal and allow  them to access and manage information related to Apilogy users. Please note that you can only add one user role." />
          <Flex className="w-full gap-3" alignX="center" pt="1rem">
            <Button
              type="button"
              variant="outline"
              onClick={() => toggleModal(null)}
            >
              Cancel
            </Button>
            <Button type="button" onClick={() => handleAddRole('admin-portal')}>
              Save
            </Button>
          </Flex>
        </CustomModal> */}

        {/* Modal Admin Verification */}
        {/* <CustomModal
          show={activeModal === ModalType.Verification}
          onClose={() => toggleModal(null)}
          title="Control Policy"
        >
          <Textfield
            iconRight={
              showPassword ? (
                <FaEye
                  color="#6B7280"
                  size={20}
                  className="cursor-pointer"
                  onClick={toggleShowPassword}
                />
              ) : (
                <FaEyeSlash
                  color="#6B7280"
                  size={20}
                  className="cursor-pointer"
                  onClick={toggleShowPassword}
                />
              )
            }
            type={showPassword ? 'text' : 'password'}
            label="Password"
            placeholder="Type your password"
            status={'normal'}
            required
            value={password}
            onChange={handlePasswordChange}
          />
          <Flex alignX="center" pt="1rem">
            <Button
              type="button"
              onClick={() => handleVerifyPassword(userLogedIn!.email, password)}
              disabled={!password}
            >
              Update
            </Button>
          </Flex>
        </CustomModal> */}
      </Container>
    </>
    
  );
};

export default ModalContainer;
